import script from "./IOrderEventItem.vue?vue&type=script&setup=true&lang=js"
export * from "./IOrderEventItem.vue?vue&type=script&setup=true&lang=js"

import "./IOrderEventItem.vue?vue&type=style&index=0&id=ccda2fba&lang=scss"

const __exports__ = script;

export default __exports__